import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { business, getSearchMetadata, getSearchPage } from "../../utils/searchMetadata";

function setMeta(selector, attributes, content) {
  let element = document.head.querySelector(selector);
  if (!element) {
    element = document.createElement("meta");
    Object.entries(attributes).forEach(([key, value]) => element.setAttribute(key, value));
    document.head.appendChild(element);
  }
  element.setAttribute("content", content);
}

export default function SearchMetadata() {
  const { pathname } = useLocation();
  const { i18n } = useTranslation();

  useEffect(() => {
    const metadata = getSearchMetadata(pathname);
    document.title = metadata.title;
    document.documentElement.lang = getSearchPage(pathname) ? "nb" : i18n.language === "en" ? "en" : "nb";
    setMeta('meta[name="description"]', { name: "description" }, metadata.description);
    setMeta('meta[name="robots"]', { name: "robots" }, metadata.robots);
    setMeta('meta[property="og:title"]', { property: "og:title" }, metadata.title);
    setMeta('meta[property="og:description"]', { property: "og:description" }, metadata.description);
    setMeta('meta[property="og:url"]', { property: "og:url" }, metadata.canonical || business.origin);
    setMeta('meta[name="twitter:title"]', { name: "twitter:title" }, metadata.title);
    setMeta('meta[name="twitter:description"]', { name: "twitter:description" }, metadata.description);
    let canonical = document.head.querySelector('link[rel="canonical"]');
    if (metadata.canonical) {
      if (!canonical) {
        canonical = document.createElement("link");
        canonical.rel = "canonical";
        document.head.appendChild(canonical);
      }
      canonical.href = metadata.canonical;
    } else {
      canonical?.remove();
    }
    document.getElementById("search-structured-data")?.remove();
    if (metadata.graph) {
      const script = document.createElement("script");
      script.id = "search-structured-data";
      script.type = "application/ld+json";
      script.textContent = JSON.stringify(metadata.graph);
      document.head.appendChild(script);
    }
  }, [pathname, i18n.language]);

  return null;
}
